import React, { useContext, useState, useRef, useEffect } from "react";
// import logo from './../images/EDVES-LOGO 2.png';
import defaultPic from "./../images/defaultPic.png";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import HamburgerSvg from "../svg/HamburgerSvg";
import { DataContext } from "../context/DataContext";
import useOnClick from "../components/common/ClosePopUp";
import { AuthContext } from "../context/AuthContext";
import { useStateWithCallbackLazy } from "use-state-with-callback";

export const tabItems = [
  {
    label: "Locker",
    path: "locker",
  },
  // {
  //     label: "CBT",
  //     path: "cbt"
  // },
  // {
  //   label: "Chatroom",
  //   path: "chatroom"
  // }
];

const TabItemContainer = ({ children }) => <div>{children}</div>;

const TabItem = ({ item }) => {
  const location = useLocation();
  const [displayDropdown, setDisplayDropdown] = useState(false);
  // const [displayDropdown, setDisplayDropdown] = useState(false);
  // const [clickedDropdown, setClickedDropdown] = useState("All Homework");

  const isCurrentRoute = location.pathname === `/${item.path}`;
  const classes = classNames({
    "px-4 mx-4 -mb-2 py-1 leading-4 text-sm text-gray-100 flex flex-column justify-center items-end font-semibold": true,
    "text-gray-200 hover:text-blue-100 transform transition ease-in-out duration-100":
      !isCurrentRoute,
    "text-blue-100": isCurrentRoute,
  });
  const showBar = classNames({
    "w-24 mx-4 -mb-2 h-1 inline-block": !isCurrentRoute,
    "w-24 mx-4 -mb-2 h-1 bg-blue-100 inline-block rounded-t": isCurrentRoute,
  });

  const BottomBar = () => <span className={showBar} />;

  return (
    // <div className={`${(localStorage.getItem('schoolDomain') !== 'demo.edves.net' && item.label === 'Chatroom') && 'hidden'}`}>
    <div>
      <Link to={item.path} className={classes}>
        {item.label}
      </Link>
      <BottomBar />
    </div>
  );
};

const Tabs = () => {
  const dataContext = useContext(DataContext);
  // console.log(dataContext.hideSidebar)
  return (
    <>
      {tabItems.map((items, i) => (
        <>
          <TabItemContainer className="flex flex-column" key={i}>
            <TabItem item={items} />
          </TabItemContainer>
        </>
      ))}
    </>
  );
};

const Navbar = () => {
  const authContext = useContext(AuthContext);
  const dataContext = useContext(DataContext);
  const showMenu = dataContext.showMenu;
  const [displayDropdown, setDisplayDropdown] = useState(false);
  const [clickedDropdown, setClickedDropdown] = useState("");
  const [allparentChildren, setAllparentChildren] = useState([]);
  const [reloadMe, setReloadMe] = useState(false);
  // const [selectChild, setSelectChild] = useState([]);
  const [selectChild, setSelectChild] = useStateWithCallbackLazy([]);

  useEffect(() => {
    const studentDetails = JSON.parse(localStorage.getItem("studentList"));
    const currentStudentDetails = JSON.parse(
      localStorage.getItem("studentInfo")
    );
    const newstudentDetails = JSON.parse(
      localStorage.getItem("newstudentInfo")
    );
    const mydetails = studentDetails;
    // console.log(currentStudentDetails, "currentStudentDetails");
    setClickedDropdown(currentStudentDetails[0].firstname);
    setAllparentChildren(mydetails);
  }, []);

  useEffect(() => {
    if (selectChild.length > 0) {
      localStorage.setItem("studentInfo", JSON.stringify(selectChild));
      localStorage.setItem("newstudentInfo", JSON.stringify(selectChild));
      setTimeout(() => {
        if (reloadMe) {
          window.location.reload(false);
        }
      }, 3000);
    }
  }, [selectChild]);

  const ref = useRef();
  useOnClick(ref, () => setDisplayDropdown(false));
  const schoolLogo = JSON.parse(
    localStorage.getItem("subSchoolData")
  ).school_logo;
  const studentPassport = JSON.parse(localStorage.getItem("studentInfo"))[0]
    .studentpassport;

  console.log(studentPassport, "sdrip");
  const setDisplaySidebar = () => {
    dataContext.setShowMenu(!showMenu);
  };

  const showDropdown = classNames({
    hidden: !displayDropdown,
    "bg-white absolute mt-10 z-10 text-gray-100 leading-4 text-xs border rounded-md border-gray-500": true,
  });

  const displayHomeworkContent = (item) => {
    console.log(item, "dena");
    // authContext.setStudentInfo(item);
    setSelectChild([item]);
    setReloadMe(true);

    //   setSelectChild([item], () => {
    //  });

    // alert(item);
    // setClickedDropdown(item);
    setDisplayDropdown(!displayDropdown);
    // setNoHomework(false);
    // // if (item === "New Homework") setNewHomework(true);
    // getHomeWork(item);
  };
  return (
    <nav className="flex fixed top-0 z-50 w-full justify-between px-4 bg-white h-16 items-center">
      <div
        onClick={() => setDisplaySidebar()}
        className="block sm:hidden cursor-pointer"
      >
        <HamburgerSvg />
      </div>
      <div className="w-12 h-12">
        <img src={schoolLogo} alt="logo" className="w-full object-cover" />
      </div>
      <div className="hidden sm:flex -mb-6">
        <Tabs />
      </div>
      <div className="h-12">
        <div className="flex ">
          {/* <div className="font-bold mr-4 mt-2 text-sm sm:text-base"> */}
          <img
            src={studentPassport ? studentPassport : defaultPic}
            alt="passport"
            className="h-full text-xs w-full object-cover rounded-full"
            style={{
              maxWidth: 40,
              marginRight: 3,
            }}
          />
          {/* </div> */}
          <div
            ref={ref}
            className="flex flex-col relative"
            style={{ minWidth: 140 }}
          >
            <span
              onClick={() => setDisplayDropdown(!displayDropdown)}
              className="flex justify-between items-center p-2 bg-white rounded-md border border-gray-600 h-10 cursor-pointer"
            >
              <span className="leading-4 text-xs text-gray-100 mr-3">
                {clickedDropdown}
              </span>
              <span className="pt-1">
                <svg
                  width="7"
                  height="6"
                  viewBox="0 0 7 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.76959 5.78571C3.60464 6.07143 3.19224 6.07143 3.02729 5.78571L0.0580571 0.642857C-0.1069 0.357143 0.0992962 -2.8842e-08 0.429211 0L6.36767 5.19157e-07C6.69759 5.47999e-07 6.90378 0.357143 6.73882 0.642858L3.76959 5.78571Z"
                    fill="#000114"
                  />
                </svg>
              </span>
            </span>
            <ul className={showDropdown}>
              {allparentChildren.map((item) => (
                <li
                  onClick={() => displayHomeworkContent(item)}
                  className="p-2 hover:text-blue-200 text-xs rounded border-md border-gray-200 cursor-pointer transition ease-in-out duration-100 flex"
                >
                  <img
                    src={item.studentpassport || defaultPic}
                    alt={`${item.firstname.charAt(0)} ${item.surname.charAt(
                      0
                    )}`}
                    className="h-full text-xs w-full object-cover rounded-full"
                    style={{
                      maxWidth: 20,
                      marginRight: 3,
                      maxWidth: 20,
                      marginRight: 3,
                      border: "1px solid",
                      background: "#1f87b0",
                      color: "#fff",
                      fontSize: 10,
                      textAlign: "center",
                    }}
                  />
                  {item.firstname} {item.surname}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
